<template>
	<div
		class="widthFull section01 whiteBg min-height-calc"
		id="how-partecipate"
	>
		<div class="container py-4 ">

			<div class="row justify-content-center mb-3">
				<h3 class="col-12 center Bold pb-2 color-2">
					Come partecipare </h3>
			</div>

			<div class="row">
				<div class="col-12">

					<div class="row mb-5 mb-lg-3 mb-lg-0">
						<div class="col-6 col-lg-2 offset-lg-1 flex-center">

							<img
								src="../../assets/images/1.png"
								:alt="altImg"
								class="img-fluid"
							>
						</div>
						<div class="col-6 col-lg-2 flex-center">
							<img
								src="../../assets/images/come_partecipare1.png"
								:alt="altImg"
								class="img-fluid max-h-220"
							>
						</div>
						<div class="col-12 col-lg-5 d-flex flex-center">
							<h3 class="Regular color-2 text-center text-lg-left">
								Dal <b> 01 marzo al 30 aprile 2022</b> <br>
								acquista almeno <b>una Birra Moretti Filtrata a Freddo 55cl </b> e conserva la prova d’acquisto.
							</h3>
						</div>
					</div>
					<div class="row mb-5 mb-lg-3 mb-lg-0">
						<div class="col-6 col-lg-2 offset-lg-1 flex-center">

							<img
								src="../../assets/images/2.png"
								:alt="altImg"
								class="img-fluid"
							>

						</div>
						<div class="col-6 col-lg-2 flex-center">
							<img
								src="../../assets/images/come_partecipare2.png"
								:alt="altImg"
								class="img-fluid max-h-220"
							>
						</div>
						<div class="col-12 col-lg-4 d-flex flex-center">
							<h3 class="Regular color-2 text-center text-lg-left">
								<b> Registrati al sito e carica
									la prova d'acquisto </b> online
								oppure <b> invia lo scontrino tramite <a
										@click="showPopUp"
										class="underline color-2"
									>WhatsApp®</a></b> al 3917054053 </b>
							</h3>
						</div>

						<div class="col-12 col-lg-3 text-center text-lg-left">
							<img
								src="../../assets/images/qr_code.png"
								:alt="altImg"
								class="img-fluid max-h-220"
							>
						</div>
					</div>
					<div class="row mb-5 mb-lg-3 mb-lg-0">
						<div class="col-6 col-lg-2 offset-lg-1 flex-center">

							<img
								src="../../assets/images/3.png"
								:alt="altImg"
								class="img-fluid"
							>
						</div>
						<div class="col-6 col-lg-2 flex-center">
							<img
								src="../../assets/images/come_partecipare3.png"
								:alt="altImg"
								class="img-fluid max-h-220"
							>
						</div>
						<div class="col-12 col-lg-5 d-flex flex-column justify-content-center align-items-flex-start">
							<div class="">
								<h3 class="Regular color-2 text-center text-lg-left">
									Scopri subito <b> se hai vinto <br> una cena con chef a casa tua in collaborazione con </b>
									<img
										src="../../assets/images/chef-booking.png"
										:alt="altImg"
										class="img-fluid max-h-30"
									>
								</h3>
							</div>

							<div class="text-center text-lg-left mt-4">

								<button-custom
									v-if="timeStore < moment(finish)"
									:to=" !isAuthenticated ? '/' : '/play'"
									:scrollTo="'#section02'"
									:type="'inv'"
								> </button-custom>

								<div
									v-else
									class="Bold color-2"
								>Il concorso è terminato</div>

								<!-- <router-link
									to="/"
									v-scroll-to="{ el: '#section02', offset: this.vw > 768 ? -this.navHeight : -this.navHeightSmall}"
									class="btn  btn-primary-inv  Bold uppercase"
								>
									Partecipa subito

								</router-link> -->
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>


<script>
	import { mapGetters } from 'vuex';
	const moment = require('moment');

	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';
	import { innerWidthMixin } from '../../mixins/innerWidthMixin';
	import { popupConfigurationMixin } from '../../mixins/popupConfigurationMixin';

	export default {
		name: 'award',

		mixins: [sharedEnvMixin, innerWidthMixin, popupConfigurationMixin],
		data() {
			return {
				oldPresent: false,
				moment: moment,
			};
		},
		methods: {
			showPopUp() {
				this.popupErrorText(
					'',
					'',
					"<h4 class='Regular p-4'>Con il numero di cellulare indicato in fase di registrazione potrai partecipare anche tramite <b>WhatsApp®</b> inviando la tua prova d'acquisto al numero <b>3917054053</b></h4>",
					'',
					''
				);
			},
		},

		mounted: function () {
			window.addEventListener('resize', this.handleResize);
		},
		computed: {
			...mapGetters([
				'isAuthenticated',
				'authStatus',
				'getPromotions',
				'getOldPromotions',
			]),
			timeStore() {
				return this.$timestore.now;
			},
		},
	};
</script>
